<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="tw-flex tw-items-center tw-justify-center tw-mt-2">
            <l-password-reset-form :user-id="userId" :token="token" />
        </div>
    </div>
</template>

<script>
import LPasswordResetForm from "@/components/LAuth/LPasswordResetForm";

export default {
    components: {
        LPasswordResetForm,
    },
    props: {
        userId: {
            type: String,
            required: true,
        },
        token: {
            type: String,
            default: "",
        },
    },
};
</script>
